import script from "./CloseIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CloseIcon.vue?vue&type=script&setup=true&lang=js"

import "./CloseIcon.vue?vue&type=style&index=0&id=4e8ddbb2&lang=css"

const __exports__ = script;

export default __exports__